import _ from "lodash";
import {PINTEREST_PIN_BULK_UPLOAD_CSV_HEADER} from "../constants/pinterest-pin-sync.constant";

export {
    prepareSingleDesignPinterestPinsList,
    generatePinterestPinsForDesign,
    prepareBulkUploadPinsCSVData,
}

const prepareSingleDesignPinterestPinsList = (designDetail, pinterestImage, pinterestBoard) => {
    const pinterestPinsList = [];

    const contentList = designDetail?.content?.contentList || [];
    const variantsList = designDetail?.variants || [];
    const tags = designDetail.designTags.join(', ') || '';

    _.forEach(pinterestImage.cards, (card, index) => {
        const content = contentList[index];
        const title = variantsList[index]?.label || designDetail.name;
        const description = prepareDescriptionForPinterestPin(content, designDetail.designTags);
        const sectionId = pinterestBoard.quoteSections[designDetail.quoteId];

        const media_source = {
            source_type: 'image_url',
            url: card.downloadUrl,
            is_standard: true,
        }

        /*const media_source = {
            source_type: 'image_base64',
            content_type: 'image/png',
            data: _.replace(base64DataByCardMap[card?.cardName], /^data:image\/\w+;base64,/, ""),
            is_standard: true,
        }*/

        const pinterestPin = {
            title: content?.metaTitle || title,
            link: card.url,
            description: description,
            alt_text: title,
            board_id: pinterestBoard.id,
            board_section_id: sectionId,
            media_source: media_source,
        }

        pinterestPinsList.push(pinterestPin);
    });

    return pinterestPinsList;
}

const prepareDescriptionForPinterestPin = (content, designTags) => {
    let description = content?.facebookPost || '';

    if (!content?.facebookPost) {
        description = content?.productDescription || '';
    }

    let currentTags = [];
    let totalChars = description.length + 2;

    _.forEach(_.shuffle(designTags), (tag) => {
        totalChars += tag.length + 2;

        if (totalChars <= 790) {
            currentTags.push(tag);
        }
    });

    if (currentTags.length) {
        description += ' | ' + currentTags.join(', ');
    }

    if (description.length > 800) {
        description = description.substring(0, 800);
    }

    return description;
}

const generatePinterestPinsForDesign = (designDetail, pinterestImage, pinterestPinSync) => {
    const designsMap = pinterestPinSync.designs || {};
    const designPinterestPinSync = designsMap[designDetail.id] || {};

    designPinterestPinSync.totalVariants = designDetail?.variants?.length || 0;
    designPinterestPinSync.pinsList = prepareSingleDesignPinterestPinsListForBulkUpload(designDetail, pinterestImage);

    designsMap[designDetail.id] = designPinterestPinSync;
    pinterestPinSync.designs = designsMap;
}

const prepareSingleDesignPinterestPinsListForBulkUpload = (designDetail, pinterestImage) => {
    const pinterestPinsList = [];
    let pinterestBoard = _.kebabCase(designDetail?.parent) + '/' + _.kebabCase(designDetail?.quoteName);

    if (pinterestBoard.indexOf('3-d-') > -1) {
        pinterestBoard = _.replace(pinterestBoard, '3-d- ', '3D-');
    }

    const contentList = designDetail?.content?.contentList || [];
    const variantsList = designDetail?.variants || [];
    const tags = designDetail.designTags.join(', ') || '';

    _.forEach(pinterestImage.cards, (card, index) => {
        const description = contentList[index]?.productDescription || (designDetail.label + ' | ' + tags);

        const pinterestPin = {
            title: variantsList[index]?.label || designDetail.name,
            description: description,
            board: pinterestBoard,
            link: card.url,
            mediaUrl: card.downloadUrl,
            keywords: tags
        }

        pinterestPinsList.push(pinterestPin);
    });

    return pinterestPinsList;
}

const prepareBulkUploadPinsCSVData = (pinterestPinSync) => {
    const csvData = [];
    const attributes = _.map(PINTEREST_PIN_BULK_UPLOAD_CSV_HEADER, 'key');

    _.forEach(pinterestPinSync.designs, (design, designId) => {
        _.forEach(design.pinsList, (pin) => {
            const pinData = {};

            _.forEach(attributes, (attribute) => {
                pinData[attribute] = pin[attribute] || '';
            });

            csvData.push(pinData);
        });
    });

    return csvData;
}
